import { apiRequest } from '@/core';
import { type Competitor } from '@/slices/logos/types';
import { type PaginatedResponse } from '@/types/pagination';

export const fetchCompetitorLogosRequest = async ({
  search,
  missingLogo,
  page,
}: {
  search?: string;
  missingLogo?: boolean;
  page?: number;
}) =>
  apiRequest<PaginatedResponse<Competitor>>({
    endpoint: `api/logos`,
    params: {
      search,
      missingLogo,
      page,
    },
  });
